<script>
import XMark from "@/Components/Icons/XMark.vue";
import CheckMark from "@/Components/Icons/CheckMark.vue";
import ExclamationTriangle from "@/Components/Icons/ExclamationTriangle.vue";

export default {
    components: {ExclamationTriangle, CheckMark, XMark},

    props: {
        condition: {
            type: Boolean,
            required: true,
        },
    }
}
</script>

<template>
    <CheckMark v-if="condition" />
    <ExclamationTriangle v-if="! condition"/>
</template>
